<template>
  <div v-if="obj">
    <el-drawer visible="visible" direction="ttb" :with-header="false" size="100%">
      <!-- <van-popup v-model="visible" position="top" class="HideScrollbar"> -->
      <div class="main">
        <!-- <pre>{{ obj }}</pre> -->
        <h3>
          <el-button class="back" type="text" icon="el-icon-back" @click="onCancel" />
          {{ obj.id }}
        </h3>
        <el-form ref="form" :model="obj" label-width="120px">
          <el-form-item label="群組名稱" v-if="!isEditMode">
            <el-input v-model="obj.id" placeholder="名稱"></el-input>
          </el-form-item>
          <el-form-item label="顯示名稱">
            <el-input v-model="obj.text" placeholder="名稱"></el-input>
          </el-form-item>

          <el-form-item label="類型">
            <el-radio-group v-model="obj.type">
              <el-radio v-for="r in columns" :key="r.value" :label="r.value">
                {{ r.text }}
              </el-radio>
            </el-radio-group>
            <div class="tip" v-if="columns.find((r) => r.value == obj.type)">
              {{ columns.find((r) => r.value == obj.type).tip }}
            </div>
          </el-form-item>
          <el-form-item label="數量">
            <el-input
              v-model="obj.limit"
              placeholder="必選多少份,不限制時請設0"
              size="small"
            ></el-input>
            <!-- <el-radio v-model="obj.lock" :label="true">必需等於{{ obj.limit }}</el-radio> 
            <el-radio v-model="obj.lock" :label="false">最多可選{{ obj.limit }}</el-radio> -->
          </el-form-item>
          <el-form-item label="複數">
            <el-checkbox v-model="obj.num">同品項允許複選</el-checkbox>
          </el-form-item>
          <!-- <el-form-item label="備註">
            <el-input v-model="obj.remark" placeholder="備註"></el-input>
          </el-form-item> -->

          <el-form-item label="選擇餐點">
            <el-select
              v-model="options"
              multiple
              filterable
              default-first-option
              placeholder="請選擇"
            >
              <el-option
                v-for="item in bkmenu.menuitem"
                :key="item.TypeNo + item.ItemName"
                :label="getLabel(item)"
                :value="JSON.stringify(item)"
              >
              </el-option>
            </el-select>
            <el-button @click="addOptions()">加入</el-button>
          </el-form-item>

          <el-form-item>
            <el-table :data="obj.options" stripe style="width: 100%" empty-text="empty">
              <el-table-column
                prop="TypeNo"
                label="類別編號"
                width="100"
              ></el-table-column>
              <el-table-column prop="ItemName" label="名稱"></el-table-column>
              <el-table-column label="金額" width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.Price1" />
                </template>
              </el-table-column>
              <el-table-column label="預設數量" width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.DefaultQty" />
                </template>
              </el-table-column>
              <!-- <el-table-column prop="ItemCode" label="代碼" width="120"></el-table-column> -->
              <el-table-column align="right" width="120">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    icon="el-icon-delete"
                    @click="handleDelete(scope.$index)"
                  />
                </template>
              </el-table-column>
              <el-table-column align="right" width="100">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    icon="el-icon-top"
                    circle
                    @click="cmdUp(scope.$index, scope.row)"
                  />
                  <el-button
                    size="mini"
                    icon="el-icon-bottom"
                    circle
                    @click="cmdDown(scope.$index, scope.row)"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <el-form-item label="指定販售時間" v-if="getConfig('chkEditGroupTime')">
            <el-card shadow="false">
              <el-form-item label="可售星期">
                <el-checkbox-group v-model="saleWeek" fill="#eee">
                  <el-checkbox v-for="r in week" :label="r" :key="r">
                    {{ weekDscp[r] }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="指定時段">
                <el-input
                  maxlength="9"
                  v-model="saleTime"
                  placeholder="9碼 mmss-mmss"
                ></el-input>
              </el-form-item>
            </el-card>
          </el-form-item>

          <el-form-item>
            <el-button @click="onOk">儲存</el-button>
            <el-button @click="onDelete">刪除群組</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- </van-popup> -->
    </el-drawer>
  </div>
</template>

<style scoped>
.tip {
  color: rgb(228, 45, 69);
}
.back {
  font-size: 2rem;
}
.van-popup {
  width: 100%;
  height: 100%;
}
.main {
  font-size: 1.6rem;
  /* line-height: 4rem; */
  padding: 1rem;
  text-align: left;
}
</style>

<script>
export default {
  data() {
    return {
      visible: false,
      obj: null,
      objString: "",
      bkmenu: null,
      options: [],
      options2: [],
      isEditMode: false,
      saleWeek: [0, 1, 2, 3, 4, 5, 6],
      week: [0, 1, 2, 3, 4, 5, 6],
      weekDscp: ["日", "一", "二", "三", "四", "五", "六"],
      saleTime: "",
      activeNames: "",
      columns: [
        {
          text: "附餐",
          value: "S2",
          tip: "例：和風沙拉、凱薩沙拉、紅茶、咖啡..",
        },
        {
          text: "口味",
          value: "AN",
          tip: "例：少冰、少糖、先上、後上 (依附在餐點後面)",
        },
        {
          text: "主餐",
          value: "S1",
          tip: "例：雙人套餐、4人分享餐、A套餐、B套餐",
        },
        {
          text: "口味項目",
          value: "A1",
          tip: "口味等於單一品項(口味項目需盤點或erp串接時使用)",
        },
        {
          text: "下一步",
          value: "NEXT",
          tip: "客製化項目：woosa下一頁",
        },
      ],
    };
  },
  methods: {
    getConfig(pId) {
      try {
        // console.log(pId);
        var config = this.bkmenu.config;
        return config[pId].value;
      } catch (error) {
        console.log(" not find key:", pId);
        return null;
      }
    },
    cmdUp(index, row) {
      if (index < 1) {
        return;
      }
      // var exttype = this.bkmenu.exttype;
      var options = this.obj.options;
      options.splice(index, 1);
      options.splice(index - 1, 0, row);
    },
    cmdDown(index, row) {
      // var exttype = this.bkmenu.exttype;

      var options = this.obj.options;
      if (index > options.length - 2) {
        return;
      }
      options.splice(index, 1);
      options.splice(index + 1, 0, row);
    },
    async onDelete() {
      this.gSure("請確認群組已未被所有餐點使用後再刪除").then(async () => {
        var body = { key: this.obj.key };
        var res = await this.apiDeleteExtgroup(body);
        console.log(res.data);
        this.visible = false;
        this.obj = null;
        this.$emit("ok");
      });
    },
    async init() {
      try {
        var res = await this.apiGetBKMenu();
        this.bkmenu = res.data;
        this.options = [];
        this.options2 = [];
      } catch (error) {
        console.log(error.toString());
      }
    },
    async showCreate() {
      await this.init();
      this.obj = {
        id: "",
        text: "",
        type: "S2",
        limit: 1,
        lock: true,
        num: false,
        remark: "",
        options: [],
      };
      this.isEditMode = false;
      this.visible = true;
    },
    async showEdit(rowIndex, obj) {
      try {
        await this.init();
        console.log("show", rowIndex, obj);
        var find = this.bkmenu.extgroup.find((r) => r.id == obj.id);
        if (find) {
          this.obj = find;
          this.saleTime = "";
          this.saleWeek = [0, 1, 2, 3, 4, 5, 6];
          this.obj.saleWeek && (this.saleWeek = this.obj.saleWeek);
          this.obj.saleTime && (this.saleTime = this.obj.saleTime);
          this.isEditMode = true;
          this.visible = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    getLabel(row) {
      var output = [];
      output.push(row.TypeNo);
      output.push(row.ItemName);
      output.push("$" + row.Price1);
      output.push(row.ItemCode);
      return output.join(" , ");
    },
    addOptions() {
      this.options.forEach((r) => {
        let row = {};
        r = JSON.parse(r);
        row.TypeNo = r.TypeNo;
        row.ItemName = r.ItemName;
        row.KPtype = r.KPtype;
        row.ItemCode = r.ItemCode;
        row.Price1 = r.Price1;
        row.Qty = 0;
        row.DefaultQty = 0;
        // row.lock =false;

        this.obj.options.push(row);
      });
      this.options = [];
    },
    onCancel() {
      this.obj = null;
      this.visible = false;
    },
    async onOk() {
      this.obj.saleWeek = this.saleWeek;
      this.obj.saleTime = this.saleTime;
      var body = { item: this.obj };
      var res = await this.apiUpdateExtgroup(body);
      var key = res.data.key;
      console.log("ok.key", key);
      this.obj = null;
      this.visible = false;
      this.$emit("ok");
    },
    async handleDelete(rowIndex) {
      this.obj.options.splice(rowIndex, 1);
    },
  },
};
</script>
